import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.9422 6.06717L7.94217 16.0672C7.88412 16.1253 7.81519 16.1714 7.73932 16.2028C7.66345 16.2343 7.58212 16.2505 7.49998 16.2505C7.41785 16.2505 7.33652 16.2343 7.26064 16.2028C7.18477 16.1714 7.11584 16.1253 7.05779 16.0672L2.68279 11.6922C2.56552 11.5749 2.49963 11.4158 2.49963 11.25C2.49963 11.0841 2.56552 10.9251 2.68279 10.8078C2.80007 10.6905 2.95913 10.6246 3.12498 10.6246C3.29083 10.6246 3.44989 10.6905 3.56717 10.8078L7.49998 14.7414L17.0578 5.18279C17.1751 5.06552 17.3341 4.99963 17.5 4.99963C17.6658 4.99963 17.8249 5.06552 17.9422 5.18279C18.0594 5.30007 18.1253 5.45913 18.1253 5.62498C18.1253 5.79083 18.0594 5.94989 17.9422 6.06717Z",
		fill: "#042914"
	})
});
export { SvgCheck as ReactComponent };
